import Dropdown from "../../../../../Components/common/Dropdown/Dropdown";

const NotificationsSidebar = ({ items, onItemSelect, selectedNotification }) => {
  return (
    <div className="products-sidebar">
      <Dropdown
        title="Notifications"
        selectedItem={selectedNotification}
        items={items}
        onItemSelect={onItemSelect}
      />
    </div>
  );
};

export default NotificationsSidebar;
